import { FormControlLabel, SxProps, Typography, FormGroup, Checkbox } from '@mui/material';

export interface ICheckboxGroupProps {
    name: string;
    data: Array<{
        value: string | number | boolean;
        label: string;
        checked: boolean;
    }>;
    onChange?: (name: string, checked: boolean) => void;
    size?: 'small' | 'medium';
    classes?: SxProps;
    disabled?: boolean;
}

const CustomCheckbox = ({ classes, name, size, data, onChange, disabled }: ICheckboxGroupProps) => {
    return (
        <FormGroup id="checkbox-group">
            {data.map((item) => {
                return (
                    <FormControlLabel
                        id={item.label}
                        key={item.label}
                        value={item.checked}
                        name={name}
                        checked={item.checked}
                        onChange={(_event, checked) => onChange && onChange(item.label, checked)}
                        control={
                            <Checkbox
                                key={`radio-${item.value}`}
                                defaultChecked
                                size={size || 'small'}
                                disabled={!item.checked && disabled}
                            />
                        }
                        label={<Typography sx={classes}>{item.label}</Typography>}
                    />
                );
            })}
        </FormGroup>
    );
};
export default CustomCheckbox;
